export class CoverageArea {
  id: number;
  zip_code: string;
  city: string;
  state: string;
  links: {
    update?: string; // PUT
    delete?: string; // DELETE
  };

  constructor(params: Partial<CoverageArea> = {}) {
    Object.assign(this, params);
  }
}
